var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useConfig } from '../config/ContentComponentLibraryProvider';
const getLinkTarget = (newWindow) => ({ target: newWindow ? '_blank' : '_self' });
export const usePromoClickEvent = () => {
    const config = useConfig();
    const promoClick = (_a, taxonomyLevel) => {
        var { assetModuleType = 'Unassigned', bannerPurpose, buyingOfficeAndGroup, creative, enhancedEcommerceInternalPromotion = 'Unassigned', id, name, newWindow, position, products, promoPeriod, promoType } = _a, props = __rest(_a, ["assetModuleType", "bannerPurpose", "buyingOfficeAndGroup", "creative", "enhancedEcommerceInternalPromotion", "id", "name", "newWindow", "position", "products", "promoPeriod", "promoType"]);
        config.onAnalyticsEvent({
            event: 'promo_click',
            ecommerce: Object.assign({ promoClick: {
                    products,
                    promotions: [
                        Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ assetModuleType }, (!!bannerPurpose && { banner_purpose: bannerPurpose })), (!!buyingOfficeAndGroup && { buying_office_and_group: buyingOfficeAndGroup })), { creative,
                            enhancedEcommerceInternalPromotion,
                            id,
                            name,
                            position }), (!!promoPeriod && { promo_period: promoPeriod })), (!!promoType && { promo_type: promoType })), (newWindow !== undefined && getLinkTarget(newWindow))), props),
                    ],
                } }, (!!taxonomyLevel && { taxonomyLevel })),
        });
    };
    return promoClick;
};
//# sourceMappingURL=use-promo-click-event.js.map